import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

interface Result {
  showFullTraffic: boolean;
  showVariationB: boolean;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-price-strikethrough';

const usePriceStrikethrough = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false, variationKey } = decision || {};

  if (!isReady) {
    return {
      showFullTraffic: false,
      showVariationB: false,
    };
  }

  return {
    showFullTraffic: enabled && variationKey === 'strikethrough_-_show',
    showVariationB: enabled && variationKey === 'strikethrough_variation_b_-_show_strikethrough',
  };
};

export default usePriceStrikethrough;
